module.exports = __webpack_public_path__ + "static/media/assemble-bg.ef097cb6.svg";